export default "__VITE_ASSET__DlRuqmgQ__"